import React, { useEffect, useState } from 'react';
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spin,
  message,
} from 'antd';
import {
  getEstados,
  getEstadosDelPadron,
  getRegimenCapital,
  getTiposDeZona,
} from 'api/catalogos';
import { getEstadosDeInfracciones } from 'api/catalogos/estadosDeInfracciones';
import { getPerimetros } from 'api/catalogos/perimetros';
import { getPuestosDeComercios } from 'api/catalogos/puestosDeComercioInformal';
import { getTiposDePersonas } from 'api/catalogos/tipoDePersona';
import { getTiposDeContratosDePolicias } from 'api/catalogos/tiposDeContratosDePolicias';
import { getTiposDeMercado } from 'api/catalogos/tiposDeMercado';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { baseURI as ciudadanoURI, postCiudadano } from 'api/cuentaunicasir';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { getTiposDeEmpresas } from 'api/empresas';
import { patchAgencia, postAgencia } from 'api/empresas/agencias';
import { patchAlcohol, postAlcohol } from 'api/empresas/alcoholes';
import { patchArrendamiento, postArrendamiento } from 'api/empresas/arrendamientos';
import { patchCasaDeEmpenio, postCasaDeEmpenio } from 'api/empresas/casasDeEmpenio';
import { patchCedula, postCedula } from 'api/empresas/cedulas';
import {
  baseURI as contribuyenteURI,
  patchContribuyente,
  postContribuyente,
} from 'api/empresas/contribuyentes';
import {
  baseURI as empresaURI,
  patchEmpresa,
  postEmpresa,
} from 'api/empresas/empresas';
import { getGirosComercioInformales } from 'api/empresas/giroDeComercioInformal';
import { getGirosMercados } from 'api/empresas/giroDeMercado';
import { patchHospedaje, postHospedaje } from 'api/empresas/hospedajes';
import { patchJuegoDeAzar, postJuegoDeAzar } from 'api/empresas/juegosDeAzar';
import { patchNomina, postNomina } from 'api/empresas/nomina';
import { patchNotario, postNotario } from 'api/empresas/notarios';
import { getZonasDeModulos } from 'api/empresas/zonasDeModulo';
import {
  getEstadosDeVehiculo,
  getTiposDeContratos,
  getTiposDeEspacios,
  getTiposDePanteones,
} from 'api/recaudacion/index';
import { getGeneros } from 'api/usuarios';
import BusquedaFormsPadrones from 'components/BusquedaFormsPadrones';
import FormsAddBusquedaAvanzada from 'components/FormsAddBusquedaAvanzada';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import ModalDireccion from 'components/Direccion/Modal';
import Table from 'components/Table';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import address from 'utils/address';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { nameValidationSearch } from 'utils/nameValidationSearch';
import { gettersPadronesCajaMap } from 'utils/padrones';
import padronToString from 'utils/padronesToString';
import toCurrency from 'utils/toCurrency';
import columnsPrediosOaxaca from 'views/Catastro/columnsPrediosOaxaca';
import { padronesEnum } from 'views/Tramites/GPM/enums';

const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';
const IPROVINAY = ENV_NAME === 'iprovinay';
const TLAJOMULCO = ENV_NAME === 'tlajomulco';

export const models = [
  'ciudadano',
  'empresa',
  'vehiculo',
  'predio',
];

const addressPropMap = Object.freeze({
  [padronesEnum.CIUDADANO]: 'direccion',
  [padronesEnum.EMPRESA]: 'direccion_de_ubicacion',
  [padronesEnum.CONTRIBUYENTE]: 'direcciones',
});

const padronesURI = Object.freeze({
  [padronesEnum.CIUDADANO]: ciudadanoURI,
  [padronesEnum.EMPRESA]: empresaURI,
  [padronesEnum.CONTRIBUYENTE]: contribuyenteURI,
});

const posts = {
  [padronesEnum.CIUDADANO]: postCiudadano,
  [padronesEnum.EMPRESA]: postEmpresa,
  [padronesEnum.HOSPEDAJE]: postHospedaje,
  [padronesEnum.ARRENDAMIENTO]: postArrendamiento,
  [padronesEnum.NOMINA]: postNomina,
  [padronesEnum.ALCOHOL]: postAlcohol,
  [padronesEnum.CEDULAR]: postCedula,
  [padronesEnum.JUEGO_DE_AZAR]: postJuegoDeAzar,
  [padronesEnum.NOTARIO]: postNotario,
  [padronesEnum.CASA_DE_EMPENIO]: postCasaDeEmpenio,
  [padronesEnum.AGENCIA]: postAgencia,
  [padronesEnum.CONTRIBUYENTE]: postContribuyente,
};

const patches = {
  [padronesEnum.CIUDADANO]: patchCiudadano,
  [padronesEnum.EMPRESA]: patchEmpresa,
  [padronesEnum.HOSPEDAJE]: patchHospedaje,
  [padronesEnum.ARRENDAMIENTO]: patchArrendamiento,
  [padronesEnum.NOMINA]: patchNomina,
  [padronesEnum.ALCOHOL]: patchAlcohol,
  [padronesEnum.CEDULAR]: patchCedula,
  [padronesEnum.JUEGO_DE_AZAR]: patchJuegoDeAzar,
  [padronesEnum.NOTARIO]: patchNotario,
  [padronesEnum.CASA_DE_EMPENIO]: patchCasaDeEmpenio,
  [padronesEnum.AGENCIA]: patchAgencia,
  [padronesEnum.CONTRIBUYENTE]: patchContribuyente,
};

const BusquedaAvanzadaPadrones = ({
  visible,
  setVisible,
  callback,
  dataExterno,
  setDataExterno,
  tipoDePadron,
  msgAsignarEntidad,
  inputQ,
  setInputQ,
  allowAdd,
  allowEdit,
  extraParams,
  contribuyenteRFC,
  visibleRFC,
  visibleCURP,
  isBajaDeOtroEstado,
  showMultipleSelection,
  gpm,
  allowAddAddress,
  datosContactoOpcionales,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ results: [], count: 1 });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const {
    estadosGlobales,
    estadosCiviles,
    generos,
    padrones,
    tiposDeEstablecimiento,
    tiposDeEmpresa,
    estados,
    tiposDePersonas,
    regimenDeCapital,
    estadosDelVehiculo,
    estadosDelPadron,
  } = useSelector((state) => state.catalogs);
  const [currentPage, setCurrentPage] = useState(1);
  // const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const [unidadesRecaudadoras, setUnidadesRecaudadoras] = useState([]);
  const [tipoDeZonasExclusivas, setTipoDeZonasExclusivas] = useState([]);
  const [tipoDeContrato, setTipoDeContrato] = useState([]);
  const [tipoDeContratoPanteones, setTipoDeContratoPanteones] = useState([]);
  const [estadoDeInfraccion, setEstadoDeInfraccion] = useState([]);
  const [tiposDePanteones, setTiposDePanteones] = useState([]);
  const [tiposDeEspacios, setTiposDeEspacios] = useState([]);
  const [objectKeys, setObjectKeys] = useState([]);
  const [padronAdded, setPadronAdded] = useState(null);

  // busqueda Avanzada dentro de la busqueda Avanzada de empresas
  const [empresaFound, setEmpresaFound] = useState([]);
  const [visibleBusquedaAvanzada, setVisibleBusquedaAvanzada] = useState(false);

  // busqueda Avanzada dentro de la busqueda Avanzada de Ciudadanos
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [visibleBusquedaAvanzadaCiudadano, setVisibleBusquedaAvanzadaCiudadano] = useState(false);

  // busqueda Avanzada dentro de la busqueda Avanzada de Contribuyentes
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [visibleBusquedaAvanzadaContribuyente,
    setVisibleBusquedaAvanzadaContribuyente] = useState(false);
  const [parentID, setParentID] = useState(0);

  const [subPadronesDeEmpresa, setSubPadronesDeEmpresa] = useState([]);
  const [tipoDeMercado, setTipoDeMercado] = useState([]);
  const [giros, setGiros] = useState([]);
  const [girosVia, setGirosVia] = useState([]);
  const [tipoDePuesto, setTipoDePuesto] = useState([]);
  const [perimetros, setPerimetros] = useState([]);
  const [zonas, setZonas] = useState([]);

  const onCancel = () => {
    setVisible(false);
    setData({ results: [], count: 1 });
    setDataExterno({ results: [], count: 1 });
    form.resetFields();
    setSelectedRowKeys([]);
    setObjectKeys([]);
    setCurrentPage(1);
    setEmpresaFound([]);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    setVisibleBusquedaAvanzada(false);
    setVisibleBusquedaAvanzadaCiudadano(false);
    setVisibleBusquedaAvanzadaContribuyente(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const [
        _unidadesRecaudadoras,
        _tiposDeZonas,
        _tipoDeContrato,
        _estadoInfraccion,
        _tipoDeContratoPanteon,
        _tiposDePanteones,
        _tiposDeEspacios,
        _tipoDeMercado,
        _tipoDePuesto,
        _giros,
        _girosVia,
        _perimetros,
        _zonas,
      ] = await Promise.all([
        getUnidadesDeRecaudacion(),
        getTiposDeZona(),
        getTiposDeContratosDePolicias(),
        getEstadosDeInfracciones(),
        getTiposDeContratos(),
        getTiposDePanteones(),
        getTiposDeEspacios(),
        getTiposDeMercado(),
        getPuestosDeComercios(),
        getGirosMercados(),
        getGirosComercioInformales(),
        getPerimetros(),
        getZonasDeModulos(),
      ]);
      await Promise.all([
        getEstadosDelPadron(),
        getEstadosDeVehiculo(),
        getRegimenCapital(),
        getTiposDePersonas(),
        getTiposDeEmpresas(),
        getEstados(),
        getGeneros(),
      ]);
      setUnidadesRecaudadoras(_unidadesRecaudadoras);
      setTipoDeZonasExclusivas(_tiposDeZonas);
      setTipoDeContrato(_tipoDeContrato);
      setEstadoDeInfraccion(_estadoInfraccion);
      setTipoDeContratoPanteones(_tipoDeContratoPanteon);
      setTiposDeEspacios(_tiposDeEspacios);
      setTiposDePanteones(_tiposDePanteones);
      setTipoDeMercado(_tipoDeMercado);
      setGiros(_giros);
      setGirosVia(_girosVia);
      setTipoDePuesto(_tipoDePuesto);
      setPerimetros(_perimetros);
      setZonas(_zonas);
      setSubPadronesDeEmpresa(padrones
        .filter((p) => p.es_subpadron_de_empresas)
        .map((p) => p.id));
      setLoading(false);
    };
    fetchData();
  }, [visible]);

  const onCancelAdd = () => {
    setVisibleAdd(false);
    setVisibleBusquedaAvanzada(false);
    setVisibleBusquedaAvanzadaCiudadano(false);
    setVisibleBusquedaAvanzadaContribuyente(false);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    form.resetFields();
    setData({ results: [], count: 1 });
  };

  const onCancelEdit = () => {
    setVisibleEdit(false);
    setVisibleBusquedaAvanzada(false);
    setVisibleBusquedaAvanzadaCiudadano(false);
    setVisibleBusquedaAvanzadaContribuyente(false);
    setCiudadanoFound([]);
    setContribuyenteFound([]);
    form.resetFields();
    setSelectedRowKeys([]);
    setData({ results: [], count: 1 });
  };

  const concatNames = (values) => `${values?.nombre} ${values?.apellido_paterno || ''} ${values?.apellido_materno || ''}`;

  const onFinishAdd = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();

      if (!values.email) {
        delete values.email;
      }
      if (tipoDePadron === padronesEnum.CONTRIBUYENTE && values.tipo_de_persona === 2) {
        values.nombre_completo = values.razon_social;
      } else {
        values.nombre_completo = concatNames(values);
      }

      const postFunc = posts?.[tipoDePadron];
      const patchFunc = patches?.[tipoDePadron];

      if (!postFunc) {
        message.warn("Este padrón no tiene la funcionalidad de 'Agregar'");
        return;
      }

      if (!patchFunc) {
        message.warn("Este padrón no tiene la funcionalidad de 'Editar'");
        return;
      }

      const saved = visibleAdd ? await postFunc(values) : await patchFunc(selectedRowKeys, values);
      if (saved) {
        setPadronAdded(saved);
        saved.agregarDireccion = values.agregarDireccion;
        if (values.agregarDireccion && !gpm) {
          setParentID(saved.id);
          setTimeout(() => {
            setLoading(false);
            document.querySelector('#btn-direccion')?.click();
          }, 2000);
        } else {
          setParentID(0);
          if (visibleAdd) {
            onCancelAdd();
          } else {
            onCancelEdit();
          }
          setVisible(false);
          saved.fromThisEntity = true;
          callback(saved);
          if (typeof setInputQ === 'function') setInputQ();
          onCancel();
          setLoading(false);
        }
      }
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const formatParams = (values, _tipoDePadron) => {
    const output = { ...values };

    if (subPadronesDeEmpresa.includes(_tipoDePadron) && output?.rfc && 'rfc' in output) {
      output.empresa__contribuyente__rfc = output.rfc.toUpperCase();
      delete output.rfc;
    }
    return output;
  };

  const fetch = async (page = 1) => {
    await form.validateFields();
    const params = form.getFieldsValue();
    setLoading(true);
    setCurrentPage(page);
    const _data = await gettersPadronesCajaMap[tipoDePadron](formatParams({
      ...params,
      page,
    }, tipoDePadron));
    setData(_data);
    setLoading(false);
  };

  const handleSearch = async (page = 1, q = null, ignore = false) => {
    try {
      setLoading(true);
      setCurrentPage(page);
      await form.validateFields();
      setSelectedRowKeys([]);
      const values = form.getFieldsValue();
      if (ciudadanoFound.length) {
        delete values.q;
      }
      if ('tipo_propietario' in values) {
        delete values.tipo_propietario;
      }
      const keys = Object.keys(values);
      const validProps = keys.filter((prop) => values[prop]);

      let _tipoDePadron = visibleBusquedaAvanzada ? padronesEnum.EMPRESA : tipoDePadron;
      if (visibleBusquedaAvanzadaCiudadano) {
        _tipoDePadron = padronesEnum.CIUDADANO;
      }
      if (visibleBusquedaAvanzadaContribuyente) {
        _tipoDePadron = padronesEnum.CONTRIBUYENTE;
      }
      const validationName = nameValidationSearch(validProps);
      if (!(validProps.length || ignore)) {
        message.warn('Debe ingresar al menos un campo');
        return;
      }
      if (!validationName) {
        message.warn('Debe ingresar mínimo dos campos referentes a nombre');
        return;
      }

      const query = formatParams({
        page,
        ...values,
        ...{ ...inputQ, ...q },
        ...extraParams,
      }, _tipoDePadron);

      const _data = await gettersPadronesCajaMap[_tipoDePadron](query);
      setData(_data);
      if (!_data?.length && !_data?.results?.length) {
        message.warn('No se encontró ningún padrón relacionado');
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onFinishSearch = async (record) => {
    setLoading(true);
    if (tipoDePadron !== padronesEnum.CIUDADANO) {
      if (typeof setInputQ === 'function') {
        setInputQ();
      }
      setTimeout(await callback(record));
    } else if (!record.fromThisEntity) {
      msgAsignarEntidad(record);
    } else {
      if (typeof setInputQ === 'function') {
        setInputQ();
      }
      setTimeout(await callback(record));
    }
    onCancel();
    setLoading(false);
  };

  useEffect(() => {
    if (dataExterno?.results?.length || dataExterno?.length) {
      const _data = Array.isArray(dataExterno) ? { count: 1, results: dataExterno } : dataExterno;
      setData(_data);
    }
    // eslint-disable-next-line
  }, [dataExterno]);

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const alternRowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    onChange: (keys, objects) => {
      setSelectedRowKeys(keys);
      setObjectKeys(objects);
    },
    preserveSelectedRowKeys: true,
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const alternHandleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      const clone = [...selectedRowKeys];
      clone.splice(selectedRowKeys.indexOf(record.id), 1);
      setSelectedRowKeys(clone);

      // arr para seleccion multiple
      const objClone = [...objectKeys];
      objClone.splice(objectKeys.findIndex((e) => e.id === record.id), 1);
      setObjectKeys(objClone);
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
      setObjectKeys([...objectKeys, record]);
    }
  };

  const onFinishSearchCiudadanoParaEmpresa = (record) => {
    setCiudadanoFound(record);
    form.setFieldsValue({
      ciudadano: record.id,
    });
    setVisibleBusquedaAvanzadaCiudadano(false);
    setData({ results: [], count: 1 });
    setSelectedRowKeys([]);
  };

  const onFinishSearchContribuyenteParaEmpresa = (record) => {
    setContribuyenteFound(record);
    form.setFieldsValue({
      contribuyente: record.id,
    });
    setVisibleBusquedaAvanzadaCiudadano(false);
    setVisibleBusquedaAvanzadaContribuyente(false);
    setData({ results: [], count: 1 });
    setSelectedRowKeys([]);
  };

  const onFinishSearchEmpresaParaPadron = (record) => {
    setEmpresaFound(record);
    form.setFieldsValue({
      empresa: record.id,
    });
    setVisibleBusquedaAvanzada(false);
    setData({ results: [], count: 1 });
  };

  const add = () => {
    const [key] = selectedRowKeys;
    const match = (data.results || data).find((item) => item.id === key);
    if (visibleBusquedaAvanzadaCiudadano) {
      onFinishSearchCiudadanoParaEmpresa(match);
    } else if (visibleBusquedaAvanzadaContribuyente) {
      onFinishSearchContribuyenteParaEmpresa(match);
    } else if (visibleBusquedaAvanzada) {
      onFinishSearchEmpresaParaPadron(match);
    } else {
      onFinishSearch(match);
      onCancel();
    }
  };

  const altAdd = () => {
    onFinishSearch(objectKeys);
    onCancel();
  };

  const getOnCancel = () => {
    if (visibleBusquedaAvanzadaCiudadano) {
      setVisibleBusquedaAvanzadaCiudadano(false);
    } else if (visibleBusquedaAvanzadaContribuyente) {
      setVisibleBusquedaAvanzadaContribuyente(false);
    } else if (visibleBusquedaAvanzada) {
      setVisibleBusquedaAvanzada(false);
    } else if (visibleAdd) {
      onCancelAdd();
    } else {
      onCancelEdit();
    }
  };

  const controlsAdd = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: () => getOnCancel(),
    },
    !(visibleBusquedaAvanzada || visibleBusquedaAvanzadaCiudadano) && {
      text: 'Agregar',
      icon: <PlusOutlined />,
      onClick: form.submit,
    },

  ];
  const controlsEdit = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: () => getOnCancel(),
    },
    !(visibleBusquedaAvanzada || visibleBusquedaAvanzadaCiudadano) && {
      text: 'Guardar',
      icon: <EditOutlined />,
      onClick: form.submit,
    },

  ];

  const controls = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: onCancel,
    },
    {
      text: 'Limpiar',
      icon: <DeleteOutlined />,
      onClick: () => {
        setData({ results: [], count: 1 });
        form.resetFields();
      },
    },
  ];

  const getKeyAndDataIndex = () => {
    if (tipoDePadron === padronesEnum.CONTRIBUYENTE || visibleBusquedaAvanzadaContribuyente) {
      return 'clave';
    }
    if (tipoDePadron === padronesEnum.CIUDADANO || visibleBusquedaAvanzadaCiudadano) {
      return 'clave_ciudadana';
    }
    return 'clave';
  };

  const getOnClick = (record) => {
    if (visibleBusquedaAvanzadaContribuyente) {
      onFinishSearchContribuyenteParaEmpresa(record);
    } else if (visibleBusquedaAvanzadaCiudadano) {
      onFinishSearchCiudadanoParaEmpresa(record);
    } else {
      callback(record);
      onCancel();
    }
  };

  const columns1 = [
    {
      titleText: 'Clave',
      dataIndex: getKeyAndDataIndex(),
      key: getKeyAndDataIndex(),
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => (getOnClick(record))}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 150,
    },
    {
      titleText: 'Correo',
      dataIndex: tipoDePadron === padronesEnum.CIUDADANO ? 'email' : 'correo_electronico',
      key: tipoDePadron === padronesEnum.CIUDADANO ? 'email' : 'correo_electronico',
      width: 220,
    },
    {
      titleText: 'Nombre Completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      width: 400,
    },
    {
      titleText: 'Celular',
      dataIndex: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'telefono_celular' : 'numero_de_celular',
      key: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'telefono_celular' : 'numero_de_celular',
      width: 100,
    },
    {
      titleText: 'CURP',
      dataIndex: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'curp' : 'CURP',
      key: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'curp' : 'CURP',
      width: 200,
    },
    {
      titleText: 'RFC',
      dataIndex: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'rfc' : 'RFC',
      key: tipoDePadron === padronesEnum.CONTRIBUYENTE ? 'rfc' : 'RFC',
      width: 200,
    },
    tipoDePadron === padronesEnum.CONTRIBUYENTE && {
      titleText: 'Estado del Padrón',
      dataIndex: 'estado_del_padron',
      key: 'estado_del_padron',
      width: 150,
      catalog: {
        cat: estadosDelPadron,
        labelProp: 'descripcion',
        use: true,
      },
    },
    {
      titleText: 'Fecha de Nacimiento',
      dataIndex: 'fecha_nacimiento',
      key: 'fecha_nacimiento',
      render: (val) => (val?.format(DATE_FRONTEND_FORMAT)),
      width: 200,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columns2 = [
    {
      titleText: TLAJOMULCO ? 'Objeto Cuenta' : 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => (visibleBusquedaAvanzada ? onFinishSearchEmpresaParaPadron(record)
            : onFinishSearch(record))}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 200,
    },
    {
      titleText: TLAJOMULCO ? 'Denominación/Nombre comercial' : 'Nombre comercial',
      dataIndex: 'nombre_comercial',
      key: 'nombre_comercial',
      width: 300,
    },
    {
      titleText: 'Clave contribuyente',
      key: 'contribuyente__rfc',
      dataIndex: 'contribuyente__rfc',
      render: (val, record) => record?.contribuyente?.clave,
      filterName: 'contribuyente__rfc',
      width: 300,
    },
    {
      titleText: 'Nombre contribuyente',
      key: 'contribuyente__rfc',
      dataIndex: 'contribuyente__rfc',
      render: (val, record) => record?.contribuyente?.nombre_completo,
      filterName: 'contribuyente__rfc',
      width: 300,
    },
    {
      titleText: 'RFC',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      width: 200,
      render: (val) => (val?.rfc || 'El contribuyente no tiene RFC en su registro'),
    },
    {
      titleText: 'Página Web',
      dataIndex: 'pagina_web',
      key: 'pagina_web',
      width: 300,
    },
    {
      titleText: 'Tipo de Establecimiento',
      dataIndex: 'tipo_de_establecimiento',
      key: 'tipo_de_establecimiento',
      width: 300,
      catalog: {
        labelProp: 'nombre',
        cat: tiposDeEstablecimiento,
        use: true,
      },
    },
    {
      titleText: 'Ubicacion de Comercio',
      key: 'direccion_de_ubicacion',
      dataIndex: 'direccion_de_ubicacion',
      render: (text) => (text ? address(text) : 'El registro no tiene direccion'),
      width: 300,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const predioColumnsDefault = [
    {
      titleText: 'Clave',
      dataIndex: '_',
      key: '_',
      render: (_, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {record?.clave ?? record?.id}
        </Button>
      ),
      width: 250,
    },
    {
      titleText: 'Propietario',
      dataIndex: '_',
      key: '_',
      width: 300,
      render: (_, record) => {
        const ciudadano = record?.ciudadano;
        if (record?.nombres_de_participes?.length) {
          return record?.nombres_de_participes.join(', ');
        }
        if (ciudadano) {
          return ciudadano?.nombre_completo ?? padronToString(ciudadano, padronesEnum.CIUDADANO);
        }
        return 'Sin propietario';
      },
    },
    // !IPROVINAY && {
    //   titleText: 'CURT',
    //   dataIndex: 'CURT',
    //   key: 'CURT',
    //   width: 300,
    // },
    {
      titleText: 'Dirección',
      dataIndex: 'direccion_index',
      key: 'direccion_index',
      width: 500,
      render: (val) => address(val),
    },
    !IPROVINAY && {
      titleText: 'Clave Catastral',
      dataIndex: 'clave_catastral_municipal',
      key: 'clave_catastral_municipal',
      width: 200,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ].filter(Boolean);

  const predioColumns = {
    juarez: [
      {
        titleText: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
        width: 300,
      },
      {
        titleText: 'No. Cuenta',
        dataIndex: 'clave_catastral_municipal',
        key: 'clave_catastral_municipal',
        width: 250,
      },
      {
        titleText: 'Propietario',
        dataIndex: 'ciudadano',
        key: 'ciudadano',
        width: 300,
        render: (val) => {
          if (val) {
            return val?.nombre_completo || '';
          }
          return 'Sin propietario';
        },
      },
      {
        titleText: 'Dirección',
        dataIndex: 'direccion_index',
        key: 'direccion_index',
        width: 400,
        render: (val) => address(val),
      },
      {
        titleText: 'Valor Catastral',
        dataIndex: 'valor_catastral',
        key: 'valor_catastral',
        width: 300,
        render: (val) => toCurrency(val || 0),
        align: 'right',
      },
      {
        titleText: 'Estado',
        dataIndex: 'estados_globales',
        key: 'estados_globales',
        width: 150,
        catalog: {
          cat: estadosGlobales,
          labelProp: 'descripcion',
          use: true,
        },
      },
    ],
    oaxaca: columnsPrediosOaxaca,
  };

  const columns3 = predioColumns?.[ENV_NAME] || predioColumnsDefault;

  const columnsZonasExclusivas = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Tipo de Zona',
      dataIndex: 'tipo_de_zona_exclusiva',
      key: 'tipo_de_zona_exclusiva',
      width: 300,
      catalog: {
        labelProp: 'descripcion',
        cat: tipoDeZonasExclusivas,
        use: true,
      },
    },
    {
      titleText: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.nombre_comercial,
    },
    {
      titleText: 'Dirección',
      dataIndex: 'direccion',
      key: 'direccion',
      width: 300,
      render: (val) => address(val),
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columnsVia = [
    {
      titleText: 'Objeto Cuenta',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Propietario',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      render: (val) => (val?.nombre_completo),
      width: 200,
    },
    {
      titleText: 'Giros',
      dataIndex: 'giros',
      key: 'giros',
      render: (val) => {
        const _giros = val.map((e) => girosVia?.find((i) => i.id === e)?.descripcion);
        return _giros?.map((e) => ` ${e}`).toString();
      },
      width: 200,
    },
    {
      titleText: 'Tipo de puesto',
      key: 'tipo_puesto',
      dataIndex: 'tipo_puesto',
      width: 200,
      catalog: {
        cat: tipoDePuesto,
        use: true,
      },
    },
    {
      titleText: 'Perimetro',
      dataIndex: 'perimetro',
      key: 'perimetro',
      width: 200,
      catalog: {
        cat: perimetros,
        use: true,
      },
    },
    {
      titleText: 'Estatus de Expediente',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columnsModulos = [
    {
      titleText: 'Objeto Cuenta',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Propietario',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      render: (val) => (val?.nombre_completo),
      width: 200,
    },

    {
      titleText: 'Local',
      dataIndex: 'numero_de_puesto',
      key: 'numero_de_puesto',
      width: 200,
    },
    {
      titleText: 'Cantidad de Locales',
      dataIndex: 'numero_de_locales',
      key: 'numero_de_locales',
      width: 200,
    },
    {
      titleText: 'Superficie',
      dataIndex: 'superficie',
      key: 'superficie',
      width: 200,
    },
    {
      titleText: 'Zona',
      key: 'zona_de_modulo',
      dataIndex: 'zona_de_modulo',
      width: 200,
      catalog: {
        cat: zonas,
        use: true,
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columnsMultiple = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 200,
    },
    {
      titleText: 'Unidad Recaudadora',
      dataIndex: 'unidad_recaudadora',
      key: 'unidad_recaudadora',
      width: 300,
      catalog: {
        labelProp: 'descripcion',
        cat: unidadesRecaudadoras,
        use: true,
      },
    },
    {
      titleText: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.actividad_empresarial_especifica,
    },
    {
      titleText: 'RFC',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.contribuyente?.rfc,
    },
    {
      titleText: 'Contribuyente',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.contribuyente?.nombre_completo,
    },
  ];

  const columns4 = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 300,
    },
    {
      titleText: 'Número de Placa',
      dataIndex: 'numero_de_placa_vigente',
      key: 'numero_de_placa_vigente',
      width: 300,
    },
    {
      titleText: 'Serie',
      dataIndex: 'numero_de_identificacion_vehicular',
      key: 'numero_de_identificacion_vehicular',
      width: 300,
    },
    {
      titleText: 'Clave de Repuve',
      dataIndex: 'clave_de_repuve',
      key: 'clave_de_repuve',
      width: 300,
    },
    {
      titleText: 'Estatus del Vehículo',
      dataIndex: 'estatus_del_vehiculo',
      key: 'estatus_del_vehiculo',
      width: 300,
      catalog: {
        labelProp: 'nombre',
        cat: estadosDelVehiculo,
        use: true,
      },
    },
    {
      titleText: 'Tarjeta de Circulación',
      dataIndex: 'tarjeta_de_circulacion',
      key: 'tarjeta_de_circulacion',
      width: 300,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columns5 = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 300,
    },
    {
      titleText: 'Número de Placa',
      dataIndex: 'numero_de_placa_vigente',
      key: 'numero_de_placa_vigente',
      width: 300,
    },
    {
      titleText: 'Serie',
      dataIndex: 'serie',
      key: 'serie',
      width: 300,
    },
    {
      titleText: 'Tarjeta de Circulación',
      dataIndex: 'tarjeta_de_circulacion',
      key: 'tarjeta_de_circulacion',
      width: 300,
    },
    {
      titleText: 'Estatus del Vehículo',
      dataIndex: 'estatus_del_vehiculo',
      key: 'estatus_del_vehiculo',
      width: 300,
      catalog: {
        labelProp: 'nombre',
        cat: estadosDelVehiculo,
        use: true,
      },
    },
    {
      titleText: 'Registro Público Vehícular',
      dataIndex: 'registro_publico_vehicular',
      key: 'registro_publico_vehicular',
      width: 300,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columns6 = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 300,
    },
    {
      titleText: 'Número de Placa',
      dataIndex: 'placa',
      key: 'placa',
      width: 300,
    },
    {
      titleText: 'Serie',
      dataIndex: 'serie',
      key: 'serie',
      width: 300,
    },
    {
      titleText: 'Tarjeta de Circulación',
      dataIndex: 'tarjeta_de_circulacion',
      key: 'tarjeta_de_circulacion',
      width: 300,
    },
    {
      titleText: 'Estatus del Vehículo',
      dataIndex: 'estatus_del_vehiculo',
      key: 'estatus_del_vehiculo',
      width: 300,
      catalog: {
        labelProp: 'nombre',
        cat: estadosDelVehiculo,
        use: true,
      },
    },
    {
      titleText: 'Registro Público Vehícular',
      dataIndex: 'registro_publico_vehicular',
      key: 'registro_publico_vehicular',
      width: 300,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columnsMercados = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Contribuyente',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      width: 200,
      render: (val) => (val?.nombre_completo || 'No viene indexado aun'),
    },

    {
      titleText: 'Mercado',
      dataIndex: 'mercado',
      key: 'mercado',
      width: 200,
      render: (val) => ((val?.descripcion) || 'No cuenta con registro en este campo'),
    },
    {
      titleText: 'Tipo de Puesto',
      dataIndex: 'tipos_de_mercados',
      key: 'tipos_de_mercados',
      width: 200,
      render: (val) => (tipoDeMercado?.find((t) => t.id === val)?.descripcion || 'No cuenta con tipo de mercado en su registro'),
      // render: (val) => {
      //   const _giros = val.map((e) => giros?.find((i) => i.id === e)?.descripcion);
      //   return _giros?.map((e) => ` ${e}`).toString();
      // },
    },
    {
      titleText: 'Giro principal',
      dataIndex: 'giro_principal',
      key: 'giro_principal',
      width: 200,
      render: (val) => (giros?.find((g) => g.id === val)?.descripcion || 'No cuenta con giro en su registro'),
      // render: (val) => {
      //   const _giros = val.map((e) => giros?.find((i) => i.id === e)?.descripcion);
      //   return _giros?.map((e) => ` ${e}`).toString();
      // },
    },
  ];

  const columnsPolicia = [
    {
      titleText: 'Clave de Cuenta',
      dataIndex: 'clave_de_cuenta',
      key: 'clave_de_cuenta',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Clave de Anexo',
      dataIndex: 'clave_de_anexo',
      key: 'clave_de_anexo',
      width: 100,
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 100,
    },
    {
      titleText: 'Serie',
      dataIndex: 'serie',
      key: 'serie',
      width: 100,
    },
    {
      titleText: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.nombre_comercial,
    },
    {
      titleText: 'Direccion',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => address(val?.direccion_de_ubicacion),
    },
    {
      titleText: 'Tipo de Contrato',
      key: 'tipo_de_contrato',
      dataIndex: 'tipo_de_contrato',
      width: 200,
      catalog: {
        cat: tipoDeContrato,
      },
    },
  ];

  const columnsLicencia = [
    {
      titleText: 'Clave',
      dataIndex: 'clave_de_control',
      key: 'clave_de_control',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Dirección',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => address(val?.direccion_de_ubicacion),
    },
    {
      titleText: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.nombre_comercial,
    },
  ];

  const columnsComercio = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 200,
    },
    {
      titleText: 'Propietario',
      dataIndex: 'contribuyente',
      key: 'contribuyente',
      render: (val) => (val?.nombre_completo),
      width: 200,
    },
    {
      titleText: 'Giros',
      dataIndex: 'giros',
      key: 'giros',
      render: (val) => {
        const _giros = val.map((e) => giros?.find((i) => i.id === e)?.descripcion);
        return _giros?.map((e) => ` ${e}`).toString();
      },
      width: 200,
    },
    {
      titleText: 'Tipo de puesto',
      key: 'tipo_puesto',
      dataIndex: 'tipo_puesto',
      width: 200,
      catalog: {
        cat: tipoDePuesto,
        use: true,
      },
    },
    {
      titleText: 'Perimetro',
      dataIndex: 'perimetro',
      key: 'perimetro',
      width: 200,
    },
    {
      titleText: 'Estatus de Expediente',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
  ];

  const columnsAnuncios = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Número de Póliza',
      dataIndex: 'numero_de_poliza',
      key: 'numero_de_poliza',
      width: 300,
    },
    {
      titleText: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
      width: 300,
      render: (val) => val?.nombre_comercial,
    },
    {
      titleText: 'Dirección',
      dataIndex: 'direccion_index',
      key: 'direccion_index',
      width: 300,
      render: (val) => address(val),
    },
  ];

  const columnsInfracciones = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Serie',
      dataIndex: 'serie',
      key: 'serie',
      width: 200,
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 200,
    },
    {
      titleText: 'Placa',
      dataIndex: 'numero_de_placa',
      key: 'numero_de_placa',
      width: 200,
    },
    {
      titleText: 'Nombre de Infractor',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      // render: (val) => {
      //   if (val !== null && val !== 'UNDEFINED') {
      //     return val;
      //   }
      //   return 'A quien corresponda';
      // },
      width: 200,
    },
    {
      titleText: 'Número de Licencia',
      dataIndex: 'numero_de_licencia',
      key: 'numero_de_licencia',
      width: 200,
    },
    {
      titleText: 'Estado de la Infraccion',
      dataIndex: 'estado_de_la_infraccion',
      key: 'estado_de_la_infraccion',
      width: 200,
      catalog: {
        cat: estadoDeInfraccion,
        use: true,
      },
    },
  ];

  const columnsMultas = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={() => onFinishSearch(record)}
          disabled={loading}
        >
          {text}
        </Button>
      ),
      width: 100,
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 200,
    },
    {
      titleText: 'Folio Interno',
      dataIndex: 'folio_interno',
      key: 'folio_interno',
      width: 200,
    },
    {
      titleText: 'Dirección de Ubicación',
      dataIndex: 'direccion_de_ubicacion',
      key: 'direccion_de_ubicacion',
      render: (val) => (val ? address(val) : 'Multa sin dirección de ubicación'),
      width: 200,
    },
    {
      titleText: 'Dirección de Multa ',
      dataIndex: 'direccion_de_multa',
      key: 'direccion_de_multa',
      render: (val) => (val ? address(val) : 'Multa sin dirección'),
      width: 200,
    },
    {
      titleText: 'Estatus de Expediente',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
        use: true,
      },
    },
    {
      titleText: 'Clave',
      dataIndex: 'clave_de_cuenta',
      key: 'clave_de_cuenta',
      width: 100,
    },
  ];

  const columnsPanteones = [
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 150,
    },
    {
      titleText: 'Panteón',
      dataIndex: 'panteon',
      key: 'panteon',
      width: 150,
      render: (value) => tiposDePanteones.find((panteon) => panteon.id === value)?.descripcion,
    },
    {
      titleText: 'Contrato',
      dataIndex: 'tipo_contrato',
      key: 'tipo_contrato',
      width: 150,
      render: (value) => tipoDeContratoPanteones.find((t) => t.id === value)?.descripcion,
    },
    {
      titleText: 'Espacio',
      dataIndex: 'espacio',
      key: 'espacio',
      width: 150,
      render: (value) => tiposDeEspacios.find((e) => e.id === value)?.descripcion,
    },
  ];

  const padronesTableCustom = [
    padronesEnum.CIUDADANO,
    padronesEnum.EMPRESA,
    padronesEnum.PREDIO,
    padronesEnum.VEHICULO,
    padronesEnum.CONTRIBUYENTE,
    padronesEnum.MOTOCICLETA,
    padronesEnum.REMOLQUE,
    padronesEnum.POLICIA_ESPECIAL,
    padronesEnum.INFRACCIONES,
    padronesEnum.COMERCIO_INFORMAL,
    padronesEnum.MERCADO,
    padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO,
    padronesEnum.ZONA_EXCLUSIVA,
    padronesEnum.EXPEDIENTE_DE_ANUNCIO,
    padronesEnum.MULTAS,
    padronesEnum.LOTES_DE_PANTEON,
    padronesEnum.MODULOS,
  ];

  const getControls = () => {
    if (visibleAdd) {
      return controlsAdd;
    } if (visibleEdit) {
      return controlsEdit;
    }

    return controls;
  };

  const displayTitle = () => {
    const _padron = padrones.find((e) => e.id === tipoDePadron);
    return `Agregar ${_padron?.descripcion || ''}`;
  };

  const displayEdit = () => {
    const _padron = padrones.find((e) => e.id === tipoDePadron);
    return `Editar ${_padron?.descripcion || ''}`;
  };

  const edit = () => {
    const [key] = selectedRowKeys;
    const match = (data.results || data).find((item) => item.id === key);
    if (match) {
      form.setFieldsValue(match);
    }
    setVisibleEdit(true);
  };

  return (
    <Modal
      width="90%"
      open={visible}
      closable={false}
      footer={null}
      title={(
        <FormSubmitControls
          label={visibleAdd
            ? displayTitle()
            : `Búsqueda Avanzada ${padrones
              .find((e) => e.id === tipoDePadron)?.descripcion
            ?? ''} ${contribuyenteRFC ? `- ${contribuyenteRFC}` : ''}`}
          controls={getControls()}
          loading={loading}
        />
      )}
      onCancel={onCancel}
      forceRender={visible}
      centered
      maskClosable={false}
    >
      <Spin tip="Cargando..." spinning={loading} key={tipoDePadron}>
        <Form
          form={form}
          layout="vertical"
          onFinish={() => ((visibleAdd && !visibleBusquedaAvanzadaCiudadano)
            || (visibleEdit && !visibleBusquedaAvanzadaCiudadano)
            ? onFinishAdd() : handleSearch())}
          initialValues={{
            tipo_de_persona: 1,
            agregarDireccion: true,
            tipo_propietario: padronesEnum.CIUDADANO,
          }}
        >
          {(!visibleAdd && !visibleEdit) && (
            <BusquedaFormsPadrones
              tipoDePadron={tipoDePadron}
              form={form}
              setLoading={setLoading}
              ciudadanoFound={ciudadanoFound}
              setCiudadanoFound={setCiudadanoFound}
              visibleRFC={visibleRFC}
              visibleCURP={visibleCURP}
              catalogs={{
                generos,
                estadosCiviles,
                tiposDeEstablecimiento,
                unidadesRecaudadoras,
                tipoDeZonasExclusivas,
                tipoDeContrato,
                tipoDeContratoPanteones,
                tiposDeEspacios,
                tiposDePanteones,
                girosVia,
                perimetros,
                tipoDePuesto,
                zonas,
              }}
            />
          )}
          {(visibleAdd || visibleEdit) && (
            <FormsAddBusquedaAvanzada
              isBajaDeOtroEstado={isBajaDeOtroEstado}
              ciudadanoFound={ciudadanoFound}
              contribuyenteFound={contribuyenteFound}
              empresaFound={empresaFound}
              form={form}
              setCiudadanoFound={setCiudadanoFound}
              setContribuyenteFound={setContribuyenteFound}
              setEmpresaFound={setEmpresaFound}
              setLoading={setLoading}
              setVisibleBusquedaAvanzada={setVisibleBusquedaAvanzada}
              setVisibleBusquedaAvanzadaCiudadano={setVisibleBusquedaAvanzadaCiudadano}
              setVisibleBusquedaAvanzadaContribuyente={setVisibleBusquedaAvanzadaContribuyente}
              tipoDePadron={tipoDePadron}
              visibleBusquedaAvanzada={visibleBusquedaAvanzada}
              visibleBusquedaAvanzadaCiudadano={visibleBusquedaAvanzadaCiudadano}
              visibleBusquedaAvanzadaContribuyente={visibleBusquedaAvanzadaContribuyente}
              catalogs={{
                generos,
                estadosCiviles,
                tiposDeEstablecimiento,
                unidadesRecaudadoras,
                tiposDePersonas,
                regimenDeCapital,
                tiposDeEmpresa,
                estados,
                tipoDeContrato,
              }}
              gpm={gpm}
              allowAddAddress={allowAddAddress && (gpm ? !visibleEdit : true)}
              datosContactoOpcionales={datosContactoOpcionales}
            />
          )}
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
          {/* eslint-disable-next-line max-len */}
          {(!visibleAdd || !visibleEdit || visibleBusquedaAvanzada || visibleBusquedaAvanzadaCiudadano) && (
            <Row gutter={[10, 5]} justify="end">
              {/* eslint-disable-next-line max-len */}
              {((([1, 15].includes(tipoDePadron) && (allowEdit && selectedRowKeys && !visibleEdit && !visibleAdd)) && !visibleBusquedaAvanzada) && !visibleBusquedaAvanzadaCiudadano) && (
                <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                  <Button
                    block
                    onClick={edit}
                    icon={<EditOutlined />}
                    disabled={!selectedRowKeys.length}
                  >
                    {displayEdit()}
                  </Button>
                </Col>
              )}
              {/* eslint-disable-next-line max-len */}
              {((([1, 15].includes(tipoDePadron) && (allowAdd && !visibleEdit && !visibleAdd)) && !visibleBusquedaAvanzada) && !visibleBusquedaAvanzadaCiudadano) && (
                <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                  <Button
                    block
                    onClick={() => setVisibleAdd(true)}
                    icon={<PlusOutlined />}
                  >
                    {displayTitle()}
                  </Button>
                </Col>
              )}
              {!visibleAdd && !visibleEdit && (
                <>
                  <Col xs={24} sm={24} md={6}>
                    <Button block onClick={() => handleSearch()} icon={<SearchOutlined />}>
                      Buscar
                    </Button>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Button
                      onClick={showMultipleSelection && tipoDePadron === 19 ? altAdd : add}
                      block
                      disabled={!selectedRowKeys.length || loading}
                      icon={<ShoppingCartOutlined />}
                    >
                      Cargar
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          )}
          <br />
        </Form>
        {/* eslint-disable-next-line max-len */}
        {(((!visibleAdd) && [padronesEnum.CIUDADANO, padronesEnum.CONTRIBUYENTE].includes(tipoDePadron)) || visibleBusquedaAvanzadaCiudadano) && (
          <React.Fragment key={tipoDePadron}>
            <Table
              cols={columns1}
              data={data.results}
              noControls
              allowSort={false}
              allowSearch={false}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              rowKey="id"
              hasAllViewPermission
              currentPage={currentPage}
              count={data.count}
              paginationCallback={fetch}
              pagination={false}
              mobileColIndex={0}
            />
          </React.Fragment>
        )}
        {((!visibleAdd && tipoDePadron === padronesEnum.EMPRESA) || visibleBusquedaAvanzada) && (
          <Table
            cols={columns2}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.PREDIO && (
          <Table
            cols={columns3}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.VEHICULO && (
          <Table
            cols={columns4}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.MOTOCICLETA && (
          <Table
            cols={columns5}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.REMOLQUE && (
          <Table
            cols={columns6}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.POLICIA_ESPECIAL && (
          <Table
            cols={columnsPolicia}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.INFRACCIONES && (
          <Table
            cols={columnsInfracciones}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={showMultipleSelection ? alternRowSelection : rowSelection}
            handleOnRowClick={showMultipleSelection ? alternHandleOnRowClick : handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.COMERCIO_INFORMAL && !TLAJOMULCO && (
          <Table
            cols={columnsComercio}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.MERCADO && (
          <Table
            cols={columnsMercados}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO && (
          <Table
            cols={columnsLicencia}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.ZONA_EXCLUSIVA && (
          <Table
            cols={columnsZonasExclusivas}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.EXPEDIENTE_DE_ANUNCIO && (
          <Table
            cols={columnsAnuncios}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.MULTAS && (
          <Table
            cols={columnsMultas}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.LOTES_DE_PANTEON && (
          <Table
            cols={columnsPanteones}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data?.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.COMERCIO_INFORMAL && (
          <Table
            cols={columnsVia}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data?.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {tipoDePadron === padronesEnum.MODULOS && (
          <Table
            cols={columnsModulos}
            data={data?.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data?.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
        {(!padronesTableCustom.includes(tipoDePadron)) && (
          <Table
            cols={columnsMultiple}
            data={data.results}
            noControls
            allowSort={false}
            allowSearch={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            hasAllViewPermission
            currentPage={currentPage}
            count={data.count}
            paginationCallback={fetch}
            pagination={false}
            mobileColIndex={0}
          />
        )}
      </Spin>
      {!!padronesURI[tipoDePadron] && parentID > 0 && (
        <div style={{ display: 'none' }}>
          <ModalDireccion
            baseURI={padronesURI[tipoDePadron]}
            parentID={parentID}
            addressPropName={addressPropMap[tipoDePadron]}
            callback={() => {
              callback(padronAdded);
              setPadronAdded(null);
              setParentID(0);
              setVisible(false);
              onCancel();
            }}
          />
        </div>
      )}
    </Modal>
  );
};

BusquedaAvanzadaPadrones.propTypes = {
  isBajaDeOtroEstado: PropTypes.bool,
  callback: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  dataExterno: PropTypes.oneOfType(
    [
      PropTypes.shape({ results: [], count: 0 }),
      PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
    ],
  ),
  setDataExterno: PropTypes.func,
  tipoDePadron: PropTypes.number,
  msgAsignarEntidad: PropTypes.func,
  inputQ: PropTypes.shape({}),
  setInputQ: PropTypes.func,
  allowAdd: PropTypes.bool,
  allowEdit: PropTypes.bool,
  extraParams: PropTypes.shape({
    content_type: PropTypes.number,
    object_id: PropTypes.number,
  }),
  contribuyenteRFC: PropTypes.string,
  visibleRFC: PropTypes.bool,
  visibleCURP: PropTypes.bool,
  showMultipleSelection: PropTypes.bool,
  gpm: PropTypes.bool,
  allowAddAddress: PropTypes.bool,
  datosContactoOpcionales: PropTypes.bool,
};

BusquedaAvanzadaPadrones.defaultProps = {
  isBajaDeOtroEstado: false,
  inputQ: null,
  setInputQ: null,
  tipoDePadron: 1,
  allowAdd: true,
  allowEdit: false,
  setDataExterno: () => { },
  msgAsignarEntidad: () => { },
  dataExterno: [],
  extraParams: {},
  contribuyenteRFC: null,
  visibleRFC: true,
  visibleCURP: true,
  showMultipleSelection: false,
  gpm: false,
  allowAddAddress: true,
  datosContactoOpcionales: false,
};

export default BusquedaAvanzadaPadrones;
